// eslint-disable-next-line
import React, { useCallback, useEffect, useState } from "react";
import logoIcon from "../../assest/logo2.svg";
import { LiaFacebookF } from "react-icons/lia";
import { BsTwitterX } from "react-icons/bs";
import { ImWhatsapp } from "react-icons/im";
import { FaLinkedinIn } from "react-icons/fa";
import { LuGithub } from "react-icons/lu";
import summaryApi from "../../common/Api";
import axios from "axios";
import { Link } from "react-router-dom";
import { ImAppleinc } from "react-icons/im";
import { SiSamsung,SiNikon,SiSony } from "react-icons/si";
import { GiShinyOmega } from "react-icons/gi";
const Footer = () => {
  const [category, setCategory] = useState([]);
  // const [loading, setLoading] = useState(true);

  const getProductCategory = useCallback(async () => {
    try {
      // setLoading(true);
      const response = await axios.get(summaryApi.getCategoryProduct.url);
      setCategory(response.data.data);
      return response?.data?.data || [];
    } catch (error) {
      console.log(error);
      return [];
    } finally {
      // setLoading(false);
    }
  }, []);

  useEffect(() => {
    getProductCategory();
  }, []);

  return (
    <>
      <footer
        style={{ alignContent: "flex-end" }}
        className="p-0 m-0  mx-auto  text-center w-full "
      >
        <div className="bg-white">
          <div className=" bg-white md:pt-5">
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5">
              {/* Logo Section */}
              <div className="flex justify-center items-center col-span-1 sm:col-span-1 md:col-span-1 flex-wrap gap-5 mt-4 mb-4 text-lg cursor-pointer transition-all duration-400 order-1">
                <Link to="/">
                  <img
                    className="mt-10 w-[120px] md:w-[150px]"
                    width={"180px"}
                    src={logoIcon}
                    alt="Logo"
                  />
                </Link>
              </div>

              {/* Website Links Section */}
              <div className="col-span-1 sm:col-span-1 md:col-span-1 flex-wrap gap-5 mt-4 mb-4 text-base cursor-pointer transition-all duration-400 order-1 md:order-3 ">
                <h2 className="text-gray-500 w-full flex justify-center text-lg mb-2 sm:text-xl font-bold">
                  WEBSITE
                </h2>
                <div className="flex justify-center items-center flex-wrap gap-6 pt-4 text-lg text-gray-500">
                  <Link
                    className="transition-all gap-6 duration-300 hover:text-[#32e5ff]"
                    to="/about"
                    onClick={() =>
                      window.scrollTo({ top: 0, behavior: "smooth" })
                    }
                  >
                    About Us
                  </Link>
                  <a
                    target="_blank"
                    className="transition-all gap-6 duration-300 hover:text-[#32e5ff]"
                    href="https://www.linkedin.com/in/mohamed-waleed-7372b9283"
                    onClick={() =>
                      window.scrollTo({ top: 0, behavior: "smooth" })
                    }
                  >
                    Contact Us
                  </a>
                </div>
              </div>

              {/* Electronics Links Section */}
              <div className="text-center col-span-1 sm:col-span-1 md:col-span-1 flex-wrap gap-5 mt-4 mb-4 text-sm cursor-pointer transition-all duration-500 order-3 sm:order-2 md:order-2">
                <h2 className="text-gray-500 w-full flex justify-center text-lg mb-2 sm:text-xl font-bold">
                  ELECTRONICS
                </h2>
                <div className="flex justify-center pt-2 items-center flex-wrap gap-6 text-white">
                  {category?.map((item, index) => (
                    <div
                      key={index}
                      className="flex w-1/4 sm:w-1/2 md:w-1/4 p-2 bg-black rounded-full"
                    >
                      <Link
                        className="transition-all duration-300 hover:text-[#32e5ff] w-full"
                        to={`/category-product/${encodeURIComponent(
                          item.product?.category
                        )}`}
                        onClick={() =>
                          window.scrollTo({ top: 0, behavior: "smooth" })
                        }
                      >
                        {item.product?.category}
                      </Link>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* top brands  */}
            <div className="text-center col-span-1 sm:col-span-6 md:col-span-3 flex-wrap gap-5 mt-4 mb-4 text-base cursor-pointer transition-all duration-500 ">
              <h2 className="text-gray-500 w-full flex justify-center text-lg mb-2 sm:text-xl font-bold">
                TOP BRANDS
              </h2>
              <div className="flex justify-center pt-4 items-center flex-wrap gap-6  text-gray-500">
                <span className="text-2xl text-black">
                  <ImAppleinc />
                </span>
                {/* <a
                className="transition-all  gap-6 duration-300 hover:text-[#32e5ff]"
              >
                Apple
              </a> */}
                <span className="text-5xl text-black">
                  <SiSamsung />
                </span>
                <span className="text-4xl text-black font-bold">
                <SiSony />
               </span>
               <span className="text-3xl text-black">
                <SiNikon />
               </span>
                <span className="text-2xl text-black">
                  <GiShinyOmega />
                </span>
              </div>
            </div>
          </div>

          <hr className="hidden md:block w-[100%]  bg-main-background h-[1px]" />
          <hr className="block md:hidden w-[100%]  bg-main-background h-[1px]" />

          <div className="flex flex-col items-center justify-center bg-white h-auto">
            {/* <img
          className="mt-10 hidden md:block "
          width={"180px"}
          src={logoIcon}
          alt=""
        /> */}
            <h3 className="mt-4 mb-4 hidden md:block  text-center text-gray-500 font-semibold break-words">
              Connect with us on various social media platforms to stay updated
              with the latest news on Facebook, Twitter, WhatsApp, LinkedIn, and
              GitHub.
            </h3>

            <ul className="flex flex-row flex-wrap gap-5 mt-4 mb-4 text-lg cursor-pointer transition-all duration-400 ">
              {/* <li> <LiaFacebookF/> </li> */}
              <a
                className="bg-black text-white hover:bg-[#1877f2] p-2 rounded-full transition-all duration-400 ease-in-out"
                target="_blank"
                rel="noreferrer"
                href="https://www.facebook.com/share/15819vcWpx/"
              >
                <LiaFacebookF />
              </a>
              <a
                className="bg-black text-white hover:bg-[#aab8c2] p-2 rounded-full transition-all duration-400 ease-in-out"
                target="_blank"
                rel="noreferrer"
                href="https://x.com/Mo7amedWaleeD6?t=IYqNHsoY-THModFiIb96uw&s=09"
              >
                <BsTwitterX />
              </a>
              <a
                className="bg-black text-white hover:bg-[#128c7e] p-2 rounded-full transition-all duration-400 ease-in-out"
                target="_blank"
                rel="noreferrer"
                href="https://wa.me/201064279221"
              >
                <ImWhatsapp />
              </a>
              <a
                className="bg-black text-white hover:bg-[#0a66c2] p-2 rounded-full transition-all duration-400 ease-in-out"
                target="_blank"
                rel="noreferrer"
                href="https://www.linkedin.com/in/mohamed-waleed-7372b9283"
              >
                <FaLinkedinIn />
              </a>
              <a
                className="bg-black text-white hover:bg-[#6e5494] p-2 rounded-full transition-all duration-400 ease-in-out"
                target="_blank"
                rel="noreferrer"
                href="https://github.com/Mo-waleed"
              >
                <LuGithub />
              </a>
            </ul>
          </div>

          <div className="mx-auto container  h-[35px] flex items-center justify-center gap-1">
            &copy; 2025{" "}
            <span className="gradient-text" title="linkedin">
              {" "}
              <a
                target="_blank"
                rel="noreferrer"
                href="https://linkedin.com/in/mohamed-waleed-7372b9283"
              >
                Mohamed Waleed.
              </a>{" "}
            </span>{" "}
            All rights reserved.
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
